import styled from 'styled-components'

export const HomeContainer = styled.div`
	padding: 32px;
	text-align: center;
`
